import React from 'react';

import {
    Table,
    Row,
    Spin,
    Tooltip,
    Button,
    Popconfirm
} from 'antd';

import { asyncGet, delProxyKey} from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
//import {delUser} from "../../../actions/user";
// import Edit from './edit.js';


class AgencyAnalysis extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
    }
    removeProxyItem(keyName) {
        try {
            this.props.delProxyKey(keyName).then(() => {
                this.props.asyncGet();
            });
        } catch (err) {
            alert(err);
        }
    }
    render() {
        let { list, uiStatus } = this.props;
        let { isLoading } = uiStatus;

        const columns = [
            {
                title: 'key',
                dataIndex: 'keyName',
                key: 'keyName',
                render: (text, record) => {
                    return (
                        <Tooltip placement="right" title={record.descripton}>
                            <Button>{text}</Button>
                        </Tooltip>
                    );
                },
            },
            {
                title: '宽度',
                dataIndex: 'length',
                key: 'length',
            },
            {
                title: '操作',
                render: (text, record) => {
                    return (
                        <Popconfirm
                            title="确定删除？"
                            onConfirm={() => {this.removeProxyItem(record.keyName)}}
                            okText="确定"
                            cancelText="取消">
                            <a href="javascript:;">删除</a>
                        </Popconfirm>
                    );
                },
            }
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>
                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        pagination={false}
                        defaultExpandAllRows={false}
                    />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    list: state.agentManage.list,
    uiStatus: state.agentManage.uiStatus,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    delProxyKey: keyName => dispatch(delProxyKey(keyName)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AgencyAnalysis);



// WEBPACK FOOTER //
// ./pages/monitor/agent/index.js